import React from 'react'
import className from 'classnames'
import moment from 'moment'
import {get} from 'lodash'
import axios from 'axios'


import LiftBanModal from './LiftBanModal'
import TableHeader from './TableHeader'
import Modal from './Modal'
import ModalDelete from './ModalDelete'

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers'

import { useCheckIds } from '../hooks'
import { createBannedWord } from '../lib/api'

const createBannedWordWithCallback = (...options) => requestCallback(createBannedWord(...options))

const SpamUrlsList = ({
  urls = [],
  total = 0,
}) => {
  const {
    checkIds,
    renderCheckBox,
    renderCheckBoxForCheckAll,
    shouldDisableAction,
  } = useCheckIds({
    data: urls,
  })

  const bulkDelete = () => {
    if (checkIds.length > 0) {
      requestCallback(axios.delete(`/${gon.currentProvider}/api/bulk/spam_urls`, {
        data: {
          ids: checkIds,
          authenticity_token: CSRF_TOKEN
        }
      }))
    }
  }

  const bulkBan = () => {
    if (checkIds.length > 0) {
      requestCallback(axios.post(`/${gon.currentProvider}/api/bulk/spam_urls/ban`, {
        ids: checkIds,
        authenticity_token: CSRF_TOKEN
      }))
    }
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Spam URLs list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} urls</p>
        </div>
      </div>

      <div className='TableChecker'>
        {renderCheckBoxForCheckAll()}

        <div className='TableChecker__right'>
          <a
            onClick={bulkBan}
            title='Ban'
            className='TableChecker__right__a TableChecker__right__a--no-entry'
            disabled={shouldDisableAction}
          />
          <a
            onClick={bulkDelete}
            className="TableChecker__right__a TableChecker__right__a--trash"
            title="Delete"
            disabled={shouldDisableAction}
          />
        </div>
      </div>

      <div className='Table Table--spam-urls-list'>
        {(() => {
          const columnHeaders = [
            {
              label: '',
            },
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'URL',
              sortKey: 'url'
            },
            {
              label: 'Count',
              sortKey: 'count'
            },
            {
              label: 'Created at',
              sortKey: 'created_at',
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {urls.map((url) => (
          <div
            className={className('Table__row', {
              'Table__row--active': checkIds.includes(url.id),
            })}
            key={`${url.id}_${url.createdAt}`}
            data-x={url}
          >
            <div className='Table__col'>
              {renderCheckBox(url)}
            </div>

            <div className='Table__col'>{url.id}</div>
            <div className='Table__col'>{url.url}</div>
            <div className='Table__col'>{url.count}</div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: url.createdAt !== null ?
                    moment(url.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>
              <div className='Table__controls'>
                <a
                  className='Table__controls__a Table__controls__a--no-entry'
                  onClick={() => {createBannedWordWithCallback(get(url, 'url').trim(), 'message')}}
                />
                <ModalDelete
                  type='spam_url'
                  id={get(url, 'id')}
                  klassName='Table__controls__a Table__controls__a--trash'
                  reload
                  hideText
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default SpamUrlsList
